export default __webpack_public_path__ + "static/eu2-4fa4b483fd0b27d669b93cdb22360b9b.png";